import './app.css';
import App from './App.svelte';
import * as Sentry from '@sentry/svelte';
import { ApiHostResolver } from '@automapa/svelte-automapa-template';
import availableHosts from '../available-api-hosts.json';
import { Umami } from './lib/utilities/Umami';

let useSentry = true;
if (useSentry) {
    Sentry.init({
        dsn: 'https://4561a349c871461591a59b3ab02d0761@lupus.automapa.pl/14',
        // release: 'frontend@' + window.location.hostname,
        environment: window.location.hostname,
        // dsn: "https://lastmile.dev7.indigo/sentry/sentry-proxy.php",
        integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],
        tracesSampleRate: 1,
        tracePropagationTargets: ['localhost'],
        replaysSessionSampleRate: 1,
        replaysOnErrorSampleRate: 1,
    });
}

function getCookie(name: string): string | null {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop()?.split(';').shift() || null;
    return null;
}

function getTokenFromLocalStorage(): string | null {
    const token = localStorage.getItem('token');
    if (token) {
        return token;
    }
    return null;
}

function getToken(): string {
    let token: string | null = getTokenFromLocalStorage();
    if (token) {
        return token;
    }
    token = getCookie('U');
    if (token) {
        return token;
    }
    // if host is localhost, ask for token
    if (
        window.location.hostname !== 'localhost' &&
        window.location.hostname !== 'lastmile.dev7.indigo'
    ) {
        console.log('Redirecting to login page... ');
        let lang = localStorage.getItem('locale');
        window.location.href =
            '//' + window.location.hostname + '/login/login.html' + (lang ? '?ln=' + lang : '');
        return '';
    } else {
        token = prompt('Please enter your API token');
        if (token) {
            localStorage.setItem('token', token);
            return token;
        }
    }
    // redirect to login page

    console.warn('No token provided');
    return '';
}

function onLogout() {
    console.info('main_onLogout');
    Umami.event('logout_manually')
        .then(() => {
            localStorage.removeItem('token');
            //document.cookie = 'U=; expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=.'+window.location.hostname+'; path=/;';
            let lang = localStorage.getItem('locale');
            window.location.href = '//' + window.location.hostname + '/login/login.html?e=logged_out' + (lang ? '&ln=' + lang : '');
        })
        .catch(e => console.error(e));
}

const initialSettings = {
    map_key: '', // if empty, will be populated from settings
    token: getToken(),
    apiUrl: new ApiHostResolver()
        .setAvailableApiHosts(availableHosts)
        .getApiHost(window.location.origin),
    onLogout: onLogout,
};

const productionHosts = [
    'https://etoll-dpd.automapa.pl',
    'https://etoll-demo.automapa.pl',
    'https://etoll.automapa.pl',
];

if (productionHosts.includes(window.location.origin)) {
    console.log = () => {};
    console.debug = () => {};
    console.table = () => {};
    console.info = () => {};
}

const app = new App({
    // @ts-ignore
    target: document.getElementById('app'),
    props: {
        initialSettings,
    },
});

export default app;
